import React, { ComponentProps } from 'react';
import { murmurhash } from '../../lib/js/hash';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import ContentNote from '../../_lib/components/ContentNote/ContentNote';
import ILink from '../../types/ILink';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { MetaInfoContent } from '../../_lib/components/MetaInfo';

type LatestAddition = {
  changeComment?: string;
  documentTypes: string[];
  importantChangeDate: string;
  pageLink: ILink;
};

type LatestAdditions = { resultItems: LatestAddition[] };

/**
 * Lists <a href='#latestaddition'>LatestAddition</a> items.
 */
export function LatestAdditions({ resultItems }: LatestAdditions) {
  const { t } = useSonTranslation('LatestAdditions');

  if (resultItems && resultItems.length > 0) {
    return (
      <ContentList>
        {resultItems.map(item => (
          <ContentListItem key={murmurhash(item)}>
            <article className="latest-addition">
              <ContentHeadline url={item.pageLink.url} title={item.pageLink.name} />
              <MetaInfoContent documentTypes={item.documentTypes} importantChangeDate={item.importantChangeDate} />
              <ContentNote note={item.changeComment} type={t(`messageType`)} />
            </article>
          </ContentListItem>
        ))}
      </ContentList>
    );
  }

  return <ContentMessage text={t('noLatestAdditions')} />;
}

export const LatestAdditionsBlock = asBlock(LatestAdditions, BlockType.latestadditions);
export type LatestAdditionsBlock = ComponentProps<typeof LatestAdditionsBlock>;
